/* eslint-disable no-restricted-syntax */
/**
 * 将map的key/value反转
 * @param map
 */
export const invertMap = function (map: Map<any, any>) {
    const invertedMap = new Map();
    for (const [key, value] of map.entries()) {
        // 有些托底逻辑会包含重复的 value，需要过滤，否则反转时，托底值会覆盖掉正常值
        if (!invertedMap.has(value)) {
            invertedMap.set(value, key);
        }
    }
    return invertedMap;
};
